<template>
  <collapsible-widget
    title="Dodaj WMS/WMTS"
    :maxHeight="30"
    :expand-widget="false"
    :accordion="accordion"
    ref="collapsible"
    :showBackgroundLayerError="showGlobalBackgroundLayersError"
  >
    <div v-if="layersLoading">
      <spinner class="layers-loading mt-2" :loading="true"></spinner>
    </div>
    <b-form-group v-else class="mt-2 pl-1 pr-1">
      <label for="service-url">Adres usługi WMS/WMTS</label>
      <b-form-input
        v-model="serviceUrl"
        placeholder="Adres usługi wms/wmts"
        aria-label="Adres usługi wms/wmts"
        aria-required="true"
        id="service-url"
      ></b-form-input>
      <label class="mt-2" for="wms-type">Typ usługi WMS/WMTS</label>
      <b-form-select
        v-model="type"
        aria-required="true"
        aria-label="Typusługi WMS/WMTS"
        id="wms-type"
      >
        <option value="wms">WMS</option>
        <option value="wmts">WMTS</option>
      </b-form-select>
      <!-- <label class="mt-2" for="wms-names"
        >Lista nazw warst usługi (opcjonalnie)</label
      > -->
      <!-- <b-form-select
        v-model="names"
        id="wms-names"
        aria-label="Lista nazw warst usługi (opcjonalnie)"
        multiple
      >
        <option v-for="(name, i) in namesOptions" :value="name.nazwa" :key="i">
          {{ name.etykieta }}
        </option>
      </b-form-select> -->
      <label class="mt-2" for="wms-title"
        >Tytuł nazwy warstwy (opcjonalnie)</label
      >
      <b-form-input
        v-model="title"
        id="wms-title"
        aria-label="Tytuł nazwa warstwy (opcjonalnie)"
        aria-required="true"
      ></b-form-input>
      <b-btn
        type="submit"
        variant="primary"
        class="col-md-12 mt-2"
        size="sm"
        @click="addLayer"
        >Dodaj Warstwę</b-btn
      >
    </b-form-group>
    <div v-if="formHasErrors">
      Formularz zawiera błędy, Pola Adres usługi <b>WMS/WMTS</b> oraz
      <b>Typ usługi WMS/WMTS</b> są wymagane.
    </div>
  </collapsible-widget>
</template>
<script>
import { mapGetters } from 'vuex';
import CollapsibleWidget from './CollapsibleWidget';
import CompositionLayers from './CompositionLayers';
import Spinner from './Spinner';
import { LAYERS_ADD_WMS_LAYER } from '../store/mutations.type';

export default {
  props: {
    accordion: {
      type: String,
      default: 'panel',
    },
  },
  components: {
    CollapsibleWidget,
    CompositionLayers,
    Spinner,
  },
  data() {
    return {
      selected: null,
      layers: [],
      serviceUrl: '',
      type: null,
      title: null,
      // names: [],
      formHasErrors: false,
    };
  },
  computed: {
    ...mapGetters(['layersLoading']),
    showGlobalBackgroundLayersError() {
      return (
        Array.isArray(this.layers) &&
        this.layers.length > 0 &&
        this.layers.every((l) => l.loadError)
      );
    },
    // namesOptions() {
    //   return this.tableMeta;
    // },
  },
  watch: {
    serviceUrl: function (newVal) {
      this.formHasErrors = false;
    },
    type: function (newVal) {
      this.formHasErrors = false;
    },
  },
  methods: {
    validateForm() {
      if (!this.serviceUrl || !this.type) {
        return false;
      }
      return true;
    },
    showError() {
      this.formHasErrors = true;
    },
    async addLayer() {
      if (this.validateForm()) {
        await this.$store.commit(LAYERS_ADD_WMS_LAYER, {
          url: this.serviceUrl,
          // names: this.names.length > 0 ? this.names.toString() : null,
          title: this.title,
          type: this.type,
        });
      } else this.showError();
    },
  },
};
</script>